const resource = '/api/geocoder';
export default ($axios) => ({
  getAddress(inputAddress, city) {
    return $axios.post(`${resource}/getAddress`, {
      address: inputAddress,
      city,
    });
  },
});
